// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"styles_buttonsWrapper__06Nnz","optionButton":"styles_optionButton__LlyOH"};